<template>
  <div />
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'Logout',

    async mounted() {
      this.activeLoader();
      try {
        await this.signOut();
        this.$router.replace({
          name: 'SignIn',
        });
      } catch (error) {
        this.$router.replace({
          name: 'SignIn',
        });
      }
      this.desactiveLoader();
    },

    methods: {
      ...mapActions('auth', ['signOut']),
      ...mapActions('loader', ['activeLoader', 'desactiveLoader']),
    },

    getters: {
      ...mapGetters('auth', ['authenticated']),
    },
  };
</script>
